module.exports = __webpack_public_path__ + "static/4a23af60210578be069f5064cc33cee9.svg";